import { useAuthContext } from "../context/AuthContext/AuthContext";
import { hasPriceCategoryAccess } from "../helpers/getCategoryDescendants";

export const useHasPriceAccess = (): boolean => {
  const authCtx = useAuthContext();

  if (!authCtx.isAuthenticated || !authCtx.user) {
    return false;
  }

  if (authCtx.user.showPrice === false) {
    return false;
  }

  if (authCtx.user.showPrice === true) {
    return hasPriceCategoryAccess(authCtx.user.showPriceCategories);
  }

  return hasPriceCategoryAccess(authCtx.user.showPriceCategories);
};
